import { Dispatch } from 'redux';
import { DraftCount, HasPostings, HasPublishedPostings, OnsiteInterview } from './Constants';
import { TGetState } from '~/store/types';

export interface IRawOnsiteInterview {
  breakTime: string | null;
  dates: Date[];
  hourlyRate: string;
  hoursArrival: string;
  hoursDeparture: string;
  isAssistedHygiene: boolean;
  isPaidBreakTime: boolean;
  profession: string;
  professionals?: Array<{ label: string; value: string }>;
  specialty: string;
}

export interface IStoreOnsiteInterviewPayload {
  jobPostingId: string;
  data: IRawOnsiteInterview;
}

export const storeOnsiteInterviews =
  (jobPostingId: string, payload: IRawOnsiteInterview) => (dispatch: Dispatch) => {
    dispatch({
      type: OnsiteInterview.STORE,
      payload: {
        data: payload,
        jobPostingId,
      } satisfies IStoreOnsiteInterviewPayload,
    });
  };

export interface IDeleteOnsiteInterviewPayload {
  id: string;
  jobPostingId: string;
}

export const deleteOnsiteInterview =
  ({ id, jobPostingId }: IDeleteOnsiteInterviewPayload) =>
  (dispatch: Dispatch, getState: TGetState) => {
    const { onsiteInterviews } = getState().permanentJobs;

    const interviews = onsiteInterviews[jobPostingId];

    if (!interviews || interviews?.length <= 1) return;

    const isExist = interviews.findIndex((it) => it.id === id) !== -1;

    if (!isExist) return;

    dispatch({
      type: OnsiteInterview.DELETE,
      payload: {
        id,
        jobPostingId,
      } satisfies IDeleteOnsiteInterviewPayload,
    });
  };

export interface IEditOnsiteInterviewPayload {
  postingId: string;
  onsiteInterview: {
    breakTime: string | null;
    hourlyRate: string;
    hoursArrival: string;
    hoursDeparture: string;
    id: string;
    isAssistedHygiene: boolean;
    isPaidBreakTime: boolean;
    profession: string;
    specialty: string;
  };
}

export const editOnsiteInterview =
  (payload: IEditOnsiteInterviewPayload['onsiteInterview'], postingId: string) =>
  (dispatch: Dispatch) => {
    dispatch({
      type: OnsiteInterview.EDIT,
      payload: {
        postingId,
        onsiteInterview: payload,
      } satisfies IEditOnsiteInterviewPayload,
    });
  };

export interface IClearOnsiteInterviewsPayload {
  postingId: string;
}

export const clearOnsiteInterviews = (postingId: string) => (dispatch: Dispatch) => {
  dispatch({
    type: OnsiteInterview.CLEAR,
    payload: {
      postingId,
    } satisfies IClearOnsiteInterviewsPayload,
  });
};

export interface ISetHasPostingsPayload {
  hasPostings: boolean;
}

export const setHasPostings = (hasPostings: boolean) => ({
  type: HasPostings.SET,
  payload: { hasPostings } satisfies ISetHasPostingsPayload,
});

export interface ISetHasPublishedPostingsPayload {
  hasPublishedPostings: boolean;
}

export const setHasPublishedPostings = (hasPublishedPostings: boolean) => ({
  type: HasPublishedPostings.SET,
  payload: { hasPublishedPostings } satisfies ISetHasPublishedPostingsPayload,
});

export interface ISetDraftCountPayload {
  draftCount: number;
}

export const setDraftCount = (draftCount: number) => ({
  type: DraftCount.SET,
  payload: { draftCount } satisfies ISetDraftCountPayload,
});
